import { Texture } from 'pixi.js';

const stars = new WeakMap();
// Reuse the original Gecko-button pixels, not a geometric approximation.
// The existing lever Graphics owns the colored disc and animated outer rim.
export function getOriginalKnobStar(logoTexture) {
  if (stars.has(logoTexture)) return stars.get(logoTexture);
  const source = logoTexture.source.resource;
  const canvas = document.createElement('canvas');
  canvas.width = source.naturalWidth || source.width;
  canvas.height = source.naturalHeight || source.height;
  const ctx = canvas.getContext('2d');
  ctx.drawImage(source, 0, 0);
  const pixels = ctx.getImageData(0, 0, canvas.width, canvas.height);
  for (let y = 0; y < canvas.height; y++) {
    for (let x = 0; x < canvas.width; x++) {
      const i = (y * canvas.width + x) * 4;
      const [r, g, b] = pixels.data.subarray(i, i + 3);
      const outsideStar = Math.hypot(x / canvas.width - 0.5, y / canvas.height - 0.5) > 0.37;
      const greenBackground = g - r > 45 && g - b > 45;
      if (outsideStar || greenBackground) pixels.data[i + 3] = 0;
    }
  }
  ctx.putImageData(pixels, 0, 0);
  const texture = Texture.from(canvas);
  texture.source.scaleMode = 'nearest';
  stars.set(logoTexture, texture);
  return texture;
}
